import { useEffect, useRef } from 'react';

export default function BackgroundStars() {
  const particlesContainerRef = useRef(null);

  useEffect(() => {
    // Function to load the particles.js script
    const loadParticlesScript = () => {
      return new Promise((resolve) => {
        // Check if already loaded
        if (window.particlesJS) {
          resolve();
          return;
        }
        
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js';
        script.onload = () => resolve();
        document.head.appendChild(script);
      });
    };

    // Function to initialize particles.js with the desired configuration
    const initParticles = () => {
      if (window.particlesJS && particlesContainerRef.current) {
        window.particlesJS('particles-js', {
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                value_area: 800
              }
            },
            color: {
              value: '#ff00ff'
            },
            shape: {
              type: 'circle'
            },
            opacity: {
              value: 0.5,
              random: false
            },
            size: {
              value: 3,
              random: true
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: '#00ffff',
              opacity: 0.4,
              width: 1
            },
            move: {
              enable: true,
              speed: 6,
              direction: 'none',
              random: false,
              straight: false,
              out_mode: 'out',
              bounce: false
            }
          },
          interactivity: {
            detect_on: 'canvas',
            events: {
              onhover: {
                enable: true,
                mode: 'repulse'
              },
              onclick: {
                enable: true,
                mode: 'push'
              },
              resize: true
            }
          },
          retina_detect: true
        });
      }
    };

    // Load and initialize particles.js
    const setupParticles = async () => {
      await loadParticlesScript();
      initParticles();
    };

    setupParticles();

    // Cleanup when component unmounts
    return () => {
      // Remove canvas and clean up resources
      const canvas = document.querySelector('#particles-js canvas');
      if (canvas) {
        canvas.remove();
      }
    };
  }, []);

  return (
    <div id="particles-js" ref={particlesContainerRef} className="fixed inset-0 pointer-events-none z-0"></div>
  );
} 